import { createContext, type RefObject } from 'react';

import { _SelectionRef } from '../../core/components/selection-area/types.js';

export const TimeseriesChartSelectionAreaRef = createContext<
  RefObject<_SelectionRef | null> | undefined
>(undefined);
